"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _core = _interopRequireDefault(require("./core"));

var _class = _interopRequireDefault(require("./class"));

var _date = _interopRequireDefault(require("./date"));

var Cookies = _class["default"].extend({
  constructor: function constructor() {},
  get: function get(name) {
    return _core["default"].readCookie(name);
  },
  set: function set(name, val, seconds, path, domain, secure, httpOnly) {
    var end;
    path = path || '/';

    if (!name || /^(?:expires|max-age|path|domain|secure)$/i.test(name)) {
      return false;
    }

    if (seconds) {
      var wDate = new _date["default"]();
      wDate.addSeconds(seconds);
      end = wDate.toDate().toUTCString();
    }

    var props = {
      expires: end,
      path: path,
      domain: domain,
      secure: secure,
      httpOnly: httpOnly
    };
    document.cookie = [encodeURIComponent(name) + '=' + encodeURIComponent(val)].concat(_core["default"].map(props, function (key, value) {
      if (!value) {
        return null;
      }

      if (_core["default"].inArray(key, ['secure', 'httpOnly'])) {
        return key;
      }

      return [key, value].join('=');
    })).join('; ');
    return true;
  },
  has: function has(name) {
    return !!this.get(name);
  },
  remove: function remove(name) {
    if (!name || !this.has(name)) {
      return false;
    }

    this.set(name, '', -(86400 * 365 * 10));
    return true;
  }
});

_core["default"].Cookies = Cookies;
var _default = Cookies;
exports["default"] = _default;